import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
} from '@/components/common/skeleton';

const CARD_GAP = 24;

export const DesktopMaintenanceListViewSkeleton: React.FC = () => (
  <SkeletonGroup>
    <View style={styles.hero}>
      <SkeletonCard>
        <View style={styles.cardHeader}>
          <SkeletonBone width={90} height={16} borderRadius={8} />
          <SkeletonBone width={70} height={12} />
        </View>
        <SkeletonBone width="70%" height={18} />
        <SkeletonBone width="100%" height={10} borderRadius={5} />
      </SkeletonCard>
    </View>
    <View style={styles.grid}>
      {Array.from({ length: 3 }).map((_, i) => (
        <View key={i} style={styles.tile}>
          <SkeletonCard>
            <View style={styles.cardHeader}>
              <SkeletonBone width="60%" height={14} />
              <SkeletonBone width={14} height={14} />
            </View>
          </SkeletonCard>
        </View>
      ))}
    </View>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  hero: { width: '100%', maxWidth: 720, marginBottom: CARD_GAP },
  grid: { flexDirection: 'row', flexWrap: 'wrap', gap: CARD_GAP },
  tile: { flexBasis: '31%', flexGrow: 1 },
  cardHeader: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
});
